import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import { connect } from 'react-redux';
import { submitCustomerEnquiry } from '../../../store/actions';
import { isEmpty } from "lodash";
import CustomInput from "components/CustomInput/CustomInput.js";
import { MdEmail } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
    container,
    title,
    main,
    mainRaised,
    mlAuto,
    description,
} from "assets/jss/material-kit-pro-react.js";

import authService from '../../../../components/api-authorization/AuthorizeService';

const useStyles = themse => ({
    main,
    mainRaised,
    title,
    mlAuto,
    description,
    container: {
        ...container,
        maxWidth: "970px !important",
    },
    contactContent: {
        paddingBottom: "40px",
        paddingTop: "40px",
    },
    bigMap: {
        height: "55vh",
        maxHeight: "550px",
        width: "100%",
        display: "block",
    },
    info: {
        paddingBottom: "10px",
        paddingTop: 0,
    },
    textCenter: {
        textAlign: "center !important",
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
    },
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right",
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative",
    }
})



const errorMess = (msg) => toast.error(msg, {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});

const successMess = (msg) => toast.success(msg, {
    position: "bottom-right",
    autoClose: 8000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});

class ContactInput extends React.Component {

    state = {
        message: '',
        email: '',
        name: '',
        phoneNumber: '',
        disable: false

    }

    componentDidMount() {
        if (!isEmpty(this.props.user)) {
            this.setState({ email: this.props.user.email }, () => {
            });
        }
        else {
            this.populateState();
            
        }

       
    }

    componentWillUnmount() {

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        this.setState({ email: user && user.name }, () => {
        });   
    }


    handleEmailChange = (e) => {
        this.setState({ email: e.target.value }, () => {
        });
    }

    handleUserChange = (e) => {
        this.setState({ name: e.target.value }, () => {
        });
    }

    handlePhoneNumberChange = (e) => {
        this.setState({ phoneNumber: e.target.value }, () => {
        });
    }

    handleMessageChange = (e) => {
        this.setState({ message: e.target.value }, () => {
        });
    }


    validate = async () => {
        try {

            const { message, name, phoneNumber } = this.state;

            if (isEmpty(message)) {
                errorMess("To submit comments, suggestions or feedback, please fill out the message box");
                return false;
            }

            if (isEmpty(name)) {
                errorMess("To be contacted for further information, please enter your name.");
                return false;
            }

            if (isEmpty(phoneNumber)) {
                errorMess("To be contacted for further information, please enter your contact number.");
                return false;
            }

            return true;

        } catch (e) {

        }
    }


    disbaleElements = (e) => {
        this.setState({ disable: e}, () => {
        });
    }

    contactSalesTeam = async () => {
        try {

            this.disbaleElements(true);
            if (await this.validate() === true) {

                const { message, name, phoneNumber, email } = this.state;

                var result = await this.props.submitCustomerEnquiry(message, name, phoneNumber, email);

                if (await result) {
                    successMess("Your enquiry has been successfully sent to the Sales Team!")
                    this.Reset();
                    return;
                }

                else {

                    //error reset
                    errorMess("Error has occured, please try again.");
                    this.Reset();
                    return;
                }
            }
            else {
                this.disbaleElements(false);
            }


        } catch (e) {

        }
    }


    Reset = () => {
        this.setState({
            name: '',
            message: '',
            phoneNumber: ''
        }, () => {
        });
        this.disbaleElements(false);
    }

    // UI 
    render() {

        const { classes } = this.props;

        //const css = {
        //    customInput: {
        //        fontSize: 65,
        //    }
        //}


        return (
            <div>
                <div>
                    <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                </div>


                <GridContainer style={{ backgroundColor: "#F4F4F4" }}>
                    <GridItem md={12} sm={12}>
                        <h3>
                            You can contact us with anything related to our Products. We
                            {"'"}ll get in touch with you as soon as possible.
                            <br />
                            <br />
                        </h3>
                        <form >
                            <CustomInput
                                labelText="Name *"
                                id="float"
                                formControlProps={{
                                    fullWidth: true,
                                }}
                                inputProps={{
                                    value: this.state.name,
                                    onChange: this.handleUserChange,

                                }}

                            />
                            <CustomInput
                                labelText="Email address *"
                                id="float"
                                formControlProps={{
                                    fullWidth: true,
                                }}
                                inputProps={{
                                    readOnly: true,
                                    value: this.state.email,

                                }}
                                fontSize="54px"
                            />

                            <CustomInput
                                labelText="Phone *"
                                id="float"
                                formControlProps={{
                                    fullWidth: true,
                                }}
                                inputProps={{
                                    value: this.state.phoneNumber,
                                    onChange: this.handlePhoneNumberChange,

                                }}
                            />
                            <CustomInput
                                labelText="Message *"
                                id="float"
                                formControlProps={{
                                    fullWidth: true,
                                }}
                                inputProps={{
                                    multiline: true,
                                    rows: 6,
                                    value: this.state.message,
                                    onChange: this.handleMessageChange,

                                }}
                            />



                            
                            <div className={classes.textCenter} style={{ padding: "15px" }}>

                                <Button
                                    style={{

                                        borderRadius: 2,
                                        padding: "16px 20px",
                                        fontSize: "18px"
                                    }}

                                    color="info"
                                    size="lg"
                                    target="_blank"
                                    onClick={() => this.contactSalesTeam()}
                                    disabled={this.state.disable}
                                >
                                    <MdEmail size={1000} />
                                    &nbsp;  Send Enquiry
                                </Button>

                            </div>
                        </form>



                    </GridItem>
                </GridContainer>


            </div>
        )

    }
}


const mapStateToProps = state => {
    return {
        user: state.userReducer.user
    };
};

export default connect(mapStateToProps, { submitCustomerEnquiry })(withStyles(useStyles)(ContactInput));   // used to export both the styling and redux